import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import Banner from "./components/Banner";
import SliderContainer from "./components/SliderContainer";
import { useNavigate } from "react-router-dom";

const Jili = () => {
  const navigate= useNavigate();
  const [isSidebar, setSidebar] = useState(false);
const AllGames=[
  {
    name: "Go Rush",
    GAMEID: "edef29b5eda8e2eaf721d7315491c51d",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Rush.png",
    provider: "jili"
  },
  {
    name: "Mines",
    GAMEID: "72ce7e04ce95ee94eef172c0dfd6dc17",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mines.png",
    provider: "jili"
  },
  {
    name: "Tower",
    GAMEID: "8e939551b9e785001fcb5b0a32f88aba",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tower.png",
    provider: "jili"
  },
  {
    name: "HILO",
    GAMEID: "bd8a2bb2dd63503b93cf6ac9492786ce",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/HILO.png",
    provider: "jili"
  },
  {
    name: "Limbo",
    GAMEID: "eabf08253165b6bb2646e403de625d1a",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Limbo.png",
    provider: "jili"
  },
  {
    name: "Wheel",
    GAMEID: "6e19e03c50f035ddd9ffd804c30f8c80",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wheel.png",
    provider: "jili"
  },
  {
    name: "Mines Gold",
    GAMEID: "4bceeb28b1a88c87d1ef518d7af2bba9",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mines-Gold.png",
    provider: "jili"
  },
  {
    name: "Keno",
    GAMEID: "a54e3f5e231085c7d8ba99e8ed2261fc",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Keno.png",
    provider: "jili"
  },
  {
    name: "Plinko",
    GAMEID: "e3b71c6844eb8c30f5ef210ad92725a6",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Plinko.png",
    provider: "jili"
  },
  {
    name: "Crash Bonus",
    GAMEID: "a7f3e5f210523a989a7c6b32f2f1ad42",
    "game_type": "Crash Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crash-Bonus.png",
    provider: "jili"
  }
];

const SlotsGames=[
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Royal-Fishing.png",
    name: "Royal Fishing",
    GAMEID:
      "e794bf5717aca371152df192341fe68b",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bombing-Fishing.png",
    name: "Bombing Fishing",
    GAMEID:
      "e333695bcff28acdbecc641ae6ee2b23",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dinosaur-Tycoon.png",
    name: "Dinosaur Tycoon",
    GAMEID:
      "eef3e28f0e3e7b72cbca61e7924d00f1",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jackpot-Fishing.png",
    name: "Jackpot Fishing",
    GAMEID:
      "3cf4a85cb6dcf4d8836c982c359cd72d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-Fortune.png",
    name: "Dragon Fortune",
    GAMEID:
      "1200b82493e4788d038849bca884d773",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mega-Fishing.png",
    name: "Mega Fishing",
    GAMEID:
      "caacafe3f64a6279e10a378ede09ff38",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boom-Legend.png",
    name: "Boom Legend",
    GAMEID:
      "f02ede19c5953fce22c6098d860dadf4",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Happy-Fishing.png",
    name: "Happy Fishing",
    GAMEID:
      "71c68a4ddb63bdc8488114a08e603f1c",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/All-star-Fishing.png",
    name: "All-star Fishing",
    GAMEID:
      "9ec2a18752f83e45ccedde8dfeb0f6a7",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dinosaur-Tycoon-II.png",
    name: "Dinosaur Tycoon II",
    GAMEID:
      "bbae6016f79f3df74e453eda164c08a4",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ocean-King-Jackpot.png",
    name: "Ocean King Jackpot",
    GAMEID:
      "564c48d53fcddd2bcf0bf3602d86c958",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Chin-Shi-Huang.png",
    name: "Chin Shi Huang",
    GAMEID:
      "24da72b49b0dd0e5cbef9579d09d8981",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/God-Of-Martial.png",
    name: "God Of Martial",
    GAMEID:
      "21ef8a7ddd39836979170a2e7584e333",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hot-Chilli.png",
    name: "Hot Chilli",
    GAMEID:
      "c845960c81d27d7880a636424e53964d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Tree.png",
    name: "Fortune Tree",
    GAMEID:
      "6a7e156ceec5c581cd6b9251854fe504",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/War-Of-Dragons.png",
    name: "War Of Dragons",
    GAMEID:
      "4b1d7ffaf9f66e6152ea93a6d0e4215b",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Gem-Party.png",
    name: "Gem Party",
    GAMEID:
      "756cf3c73a323b4bfec8d14864e3fada",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Ball.png",
    name: "Lucky Ball",
    GAMEID:
      "893669898cd25d9da589a384f1d004df",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hyper-Burst.png",
    name: "Hyper Burst",
    GAMEID:
      "a47b17970036b37c1347484cf6956920",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Shanghai-Beauty.png",
    name: "Shanghai Beauty",
    GAMEID:
      "795d0cae623cbf34d7f1aa93bbcded28",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fa-Fa-Fa.png",
    name: "Fa Fa Fa",
    GAMEID:
      "54c41adcf43fdb6d385e38bc09cd77ca",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Candy-Baby.png",
    name: "Candy Baby",
    GAMEID:
      "2cc3b68cbcfacac2f7ef2fe19abc3c22",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hawaii-Beauty.png",
    name: "Hawaii Beauty",
    GAMEID:
      "6409b758471b6df30c6b137b49f4d92e",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/SevenSevenSeven.png",
    name: "SevenSevenSeven",
    GAMEID:
      "61d46add6841aad4758288d68015eca6",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bubble-Beauty.png",
    name: "Bubble Beauty",
    GAMEID:
      "a78d2ed972aab8ba06181cc43c54a425",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/FortunePig.png",
    name: "FortunePig",
    GAMEID:
      "8488c76ee2afb8077fbd7eec62721215",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy777.png",
    name: "Crazy777",
    GAMEID:
      "8c62471fd4e28c084a61811a3958f7a1",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bao-boon-chin.png",
    name: "Bao boon chin",
    GAMEID:
      "8c4ebb3dc5dcf7b7fe6a26d5aadd2c3d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Night-City.png",
    name: "Night City",
    GAMEID:
      "78e29705f7c6084114f46a0aeeea1372",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fengshen.png",
    name: "Fengshen",
    GAMEID:
      "09699fd0de13edbb6c4a194d7494640b",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-FaFaFa.png",
    name: "Crazy FaFaFa",
    GAMEID:
      "a57a8d5176b54d4c825bd1eee8ab34df",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/XiYangYang.png",
    name: "XiYangYang",
    GAMEID:
      "5a962d0e31e0d4c0798db5f331327e4f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/DiamondParty.png",
    name: "DiamondParty",
    GAMEID:
      "48d598e922e8c60643218ccda302af08",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Bank.png",
    name: "Golden Bank",
    GAMEID:
      "c3f86b78938eab1b7f34159d98796e88",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-Treasure.png",
    name: "Dragon Treasure",
    GAMEID:
      "c6955c14f6c28a6c2a0c28274fec7520",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo.png",
    name: "Charge Buffalo",
    GAMEID:
      "984615c9385c42b3dad0db4a9ef89070",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Goldbricks.png",
    name: "Lucky Goldbricks",
    GAMEID:
      "d84ef530121953240116e3b2e93f6af4",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Ace.png",
    name: "Super Ace",
    GAMEID:
      "bdfb23c974a2517198c5443adeea77a8",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Money-Coming.png",
    name: "Money Coming",
    GAMEID:
      "db249defce63610fccabfa829a405232",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Queen.png",
    name: "Golden Queen",
    GAMEID:
      "8de99455c2f23f6827666fd798eb80ef",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jungle-King.png",
    name: "Jungle King",
    GAMEID:
      "4db0ec24ff55a685573c888efed47d7f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Monkey-Party.png",
    name: "Monkey Party",
    GAMEID:
      "fd369a4a7486ff303beea267ec5c8eff",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boxing-King.png",
    name: "Boxing King",
    GAMEID:
      "981f5f9675002fbeaaf24c4128b938d7",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Secret-Treasure.png",
    name: "Secret Treasure",
    GAMEID:
      "1d1f267e3a078ade8e5ccd56582ac94f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pharaoh-Treasure.png",
    name: "Pharaoh Treasure",
    GAMEID:
      "c7a69ab382bd1ff0e6eb65b90a793bdd",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Coming.png",
    name: "Lucky Coming",
    GAMEID:
      "ba858ec8e3b5e2b4da0d16b3a2330ca7",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Rich.png",
    name: "Super Rich",
    GAMEID:
      "b92f491a63ac84b106b056e9d46d35c5",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/RomaX.png",
    name: "RomaX",
    GAMEID:
      "e5ff8e72418fcc608d72ea21cc65fb70",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Empire.png",
    name: "Golden Empire",
    GAMEID:
      "490096198e28f770a3f85adb6ee49e0f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems.png",
    name: "Fortune Gems",
    GAMEID:
      "a990de177577a2e6a889aaac5f57b429",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Hunter.png",
    name: "Crazy Hunter",
    GAMEID:
      "69082f28fcd46cbfd10ce7a0051f24b6",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Party-Night.png",
    name: "Party Night",
    GAMEID:
      "d505541d522aa5ca01fc5e97cfcf2116",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Magic-Lamp.png",
    name: "Magic Lamp",
    GAMEID:
      "582a58791928760c28ec4cef3392a49f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Agent-Ace.png",
    name: "Agent Ace",
    GAMEID:
      "8a4b4929e796fda657a2d38264346509",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TWIN-WINS.png",
    name: "TWIN WINS",
    GAMEID:
      "c74b3cbda5d16f77523e41c25104e602",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ali-Baba.png",
    name: "Ali Baba",
    GAMEID:
      "cc686634b4f953754b306317799f1f39",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mega-Ace.png",
    name: "Mega Ace",
    GAMEID:
      "eba92b1d3abd5f0d37dfbe112abdf0e2",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Medusa.png",
    name: "Medusa",
    GAMEID:
      "2c17b7c4e2ce5b8bebf4bd10e3e958d7",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Book-of-Gold.png",
    name: "Book of Gold",
    GAMEID:
      "6b283c434fd44250d83b7c2420f164f9",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Thor-X.png",
    name: "Thor X",
    GAMEID:
      "7e6aa773fa802aaa9cb1f2fac464736e",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Happy-Taxi.png",
    name: "Happy Taxi",
    GAMEID:
      "1ed896aae4bdc78c984021307b1dd177",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Gold-Rush.png",
    name: "Gold Rush",
    GAMEID:
      "2a5d731e0fd60f52873a24ece11f2c0b",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mayan-Empire.png",
    name: "Mayan Empire",
    GAMEID:
      "5c2383ef253f9c36dacec4b463d61622",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Pusher.png",
    name: "Crazy Pusher",
    GAMEID:
      "00d92d5cec10cf85623938222a6c2bb6",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bone-Fortune.png",
    name: "Bone Fortune",
    GAMEID:
      "aab3048abc6a88e0759679fbe26e6a8d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/JILI-CAISHEN.png",
    name: "JILI CAISHEN",
    GAMEID:
      "11e330c2b23f106815f3b726d04e4316",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bonus-Hunter.png",
    name: "Bonus Hunter",
    GAMEID:
      "39775cdc4170e56c5f768bdee8b4fa00",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/World-Cup.png",
    name: "World Cup",
    GAMEID:
      "28374b7ad7c91838a46404f1df046e5a",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Samba.png",
    name: "Samba",
    GAMEID:
      "6d35789b2f419c1db3926350d57c58d8",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Neko-Fortune.png",
    name: "Neko Fortune",
    GAMEID:
      "9a391758f755cb30ff973e08b2df6089",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Racer.png",
    name: "Wild Racer",
    GAMEID:
      "2f0c5f96cda3c6e16b3929dd6103df8e",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pirate-Queen.png",
    name: "Pirate Queen",
    GAMEID:
      "70999d5bcf2a1d1f1fb8c82e357317f4",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Joker.png",
    name: "Golden Joker",
    GAMEID:
      "f301fe0b22d1540b1f215d282b20c642",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Ace.png",
    name: "Wild Ace",
    GAMEID:
      "9a3b65e2ae5343df349356d548f3fc4b",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Master-Tiger.png",
    name: "Master Tiger",
    GAMEID:
      "d2b48fe98ac2956eeefd2bc4f7e0335a",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems-2.png",
    name: "Fortune Gems 2",
    GAMEID:
      "664fba4da609ee82b78820b1f570f4ad",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sweet-Land.png",
    name: "Sweet Land",
    GAMEID:
      "91250a55f75a3c67ed134b99bf587225",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-King-18.png",
    name: "Cricket King 18",
    GAMEID:
      "dcf220f4e3ecca0278911a55e6f11c77",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Elf-Bingo.png",
    name: "Elf Bingo",
    GAMEID:
      "5cec2b309a8845b38f8e9b4e6d649ea2",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-Sah-75.png",
    name: "Cricket Sah 75",
    GAMEID:
      "6720a0ce1d06648ff390fbea832798a9",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Temple.png",
    name: "Golden Temple",
    GAMEID:
      "976c5497256c020ac012005f6bb166ad",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Devil-Fire.png",
    name: "Devil Fire",
    GAMEID:
      "1b4c5865131b4967513c1ee90cba4472",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bangla-Beauty.png",
    name: "Bangla Beauty",
    GAMEID:
      "6b60d159f0939a45f7b4c88a9b57499a",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Aztec-Priestess.png",
    name: "Aztec Priestess",
    GAMEID:
      "6acff19b2d911a8c695ba24371964807",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Monkey.png",
    name: "Fortune Monkey",
    GAMEID:
      "add95fc40f1ef0d56f5716ce45a56946",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dabanggg.png",
    name: "Dabanggg",
    GAMEID:
      "5404a45b06826911c3537fdf935c281f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sin-City.png",
    name: "Sin City",
    GAMEID:
      "830cac2f5da6cc1fb91cfae04b85b1e2",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/King-Arthur.png",
    name: "King Arthur",
    GAMEID:
      "fafab1a17a237d0fc0e50c20d2c2bf4c",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo-Ascent.png",
    name: "Charge Buffalo Ascent",
    GAMEID:
      "28bc4a33c985ddce6acd92422626b76f",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Witches-Night.png",
    name: "Witches Night",
    GAMEID:
      "82c5c404cf4c0790deb42a2b5653533c",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fairness-Games(BlockLobby).png",
    name: "Fairness Games(BlockLobby)",
    GAMEID:
      "1ab8d0997624c05e4aee901af1bf84dc",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-&-Tiger.png",
    name: "Dragon & Tiger",
    GAMEID:
      "dc76761a9dd2b423da6df25a6b65eab1",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dice.png",
    name: "Dice",
    GAMEID:
      "1f3869a4761544f68ce8c9ff04c18adf",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7-UP-DOWN.png",
    name: "7 UP-DOWN",
    GAMEID:
      "f897d3bfa4061b602cd0ce1d1ea88312",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Number.png",
    name: "Lucky Number",
    GAMEID:
      "f4bfb9bbf261541bc42889fe2da7f281",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Big-Small.png",
    name: "Big Small",
    GAMEID:
      "25822eb4d6459cc8b39c4f7b69b1bf2c",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Number-King.png",
    name: "Number King",
    GAMEID:
      "36d20c24669dca7630715f2e0a7c18be",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Journey-West-M.png",
    name: "Journey West M",
    GAMEID:
      "0d0a5a1731a6a05ffeb0e0f9d1948f80",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Poker-King.png",
    name: "Poker King",
    GAMEID:
      "a9b13010273fcb0284c9ef436c5fe2ff",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-&-Tiger.png",
    name: "Dragon & Tiger",
    GAMEID:
      "e7ac92d2fdd2aedca92a3521b4416f47",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/iRich-Bingo.png",
    name: "iRich Bingo",
    GAMEID:
      "a53e46bf1e31f7a960ae314dc188e8b3",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7up7down.png",
    name: "7up7down",
    GAMEID:
      "3aca3084a5c1a8c77c52d6147ee3d2ab",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Baccarat.png",
    name: "Baccarat",
    GAMEID:
      "b9c7c5f589cdaa63c4495e69eaa6dbbf",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Bingo.png",
    name: "Fortune Bingo",
    GAMEID:
      "2fd70535a3c838a438b4b8003ecce49d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sic-Bo.png",
    name: "Sic Bo",
    GAMEID:
      "de0dc8a7fd369bd39a2d5747be87825c",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Bingo.png",
    name: "Super Bingo",
    GAMEID:
      "c934e67c2a84f52ef4fb598b56f3e7ba",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bingo-Carnaval.png",
    name: "Bingo Carnaval",
    GAMEID:
      "d419ec9ab6a23590770fd77b036aed16",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Win-Drop.png",
    name: "Win Drop",
    GAMEID:
      "8211bc6e55e84d266bef9a6960940183",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Bingo.png",
    name: "Lucky Bingo",
    GAMEID:
      "c9f2470e285f3580cd761ba2e1f067e1",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jackpot-Bingo.png",
    name: "Jackpot Bingo",
    GAMEID:
      "780d43c0a98bc8f6a0705976605608c3",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Game.png",
    name: "Color Game",
    GAMEID:
      "2ac4917fbc8b2034307b0c3cdd90d416",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Goal-BIngo.png",
    name: "Go Goal BIngo",
    GAMEID:
      "4e5ddaa644badc5f68974a65bf7af02a",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Calaca-Bingo.png",
    name: "Calaca Bingo",
    GAMEID:
      "b2f05dae5370035a2675025953d1d115",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/PAPPU.png",
    name: "PAPPU",
    GAMEID:
      "e5091890bbb65a5f9ceb657351fa73c1",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/West-Hunter-Bingo.png",
    name: "West Hunter Bingo",
    GAMEID:
      "8d2c1506dc4ae4c47d23f9359d71c360",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bingo-Adventure.png",
    name: "Bingo Adventure",
    GAMEID:
      "2303867628a9a62272da7576665bbc65",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Land.png",
    name: "Golden Land",
    GAMEID:
      "05fc951a633d4c6b4bbe8c429cd63658",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Candyland-Bingo.png",
    name: "Candyland Bingo",
    GAMEID:
      "711acbdf297ce40a09dd0e9023b63f50",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Prediction.png",
    name: "Color Prediction",
    GAMEID:
      "4a64504353c2304a3061bfd31cd9a62e",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Magic-Lamp-Bingo.png",
    name: "Magic Lamp Bingo",
    GAMEID:
      "848ac1703885d5a86b54fbbf094b3b63",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pearls-of-Bingo.png",
    name: "Pearls of Bingo",
    GAMEID:
      "0995142f4685f66dfdd1a54fffa66ffa",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/European-Roulette.png",
    name: "European Roulette",
    GAMEID:
      "d4fc911a31b3a61edd83bdd95e36f3bf",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Rush.png",
    name: "Go Rush",
    GAMEID:
      "edef29b5eda8e2eaf721d7315491c51d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mines.png",
    name: "Mines",
    GAMEID:
      "72ce7e04ce95ee94eef172c0dfd6dc17",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tower.png",
    name: "Tower",
    GAMEID:
      "8e939551b9e785001fcb5b0a32f88aba",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/HILO.png",
    name: "HILO",
    GAMEID:
      "bd8a2bb2dd63503b93cf6ac9492786ce",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Limbo.png",
    name: "Limbo",
    GAMEID:
      "eabf08253165b6bb2646e403de625d1a",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wheel.png",
    name: "Wheel",
    GAMEID:
      "6e19e03c50f035ddd9ffd804c30f8c80",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mines-Gold.png",
    name: "Mines Gold",
    GAMEID:
      "4bceeb28b1a88c87d1ef518d7af2bba9",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Keno.png",
    name: "Keno",
    GAMEID:
      "a54e3f5e231085c7d8ba99e8ed2261fc",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Plinko.png",
    name: "Plinko",
    GAMEID:
      "e3b71c6844eb8c30f5ef210ad92725a6",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crash-Bonus.png",
    name: "Crash Bonus",
    GAMEID:
      "a7f3e5f210523a989a7c6b32f2f1ad42",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti.png",
    name: "TeenPatti",
    GAMEID:
      "f743cb55c2c4b737727ef144413937f4",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/AK47.png",
    name: "AK47",
    GAMEID:
      "488c377662cad37a551bde18e2fbe785",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Andar-Bahar.png",
    name: "Andar Bahar",
    GAMEID:
      "6f48b3aa0b64c79a2dc320ea021148b5",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Rummy.png",
    name: "Rummy",
    GAMEID:
      "ae632f32c3a1e6803f9a6fbec16be28e",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak.png",
    name: "Callbreak",
    GAMEID:
      "9092b5a56e001c60850c4c1184c53e07",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-Joker.png",
    name: "TeenPatti Joker",
    GAMEID:
      "1a4eaca67612e65fdcae43f4c8a667a4",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak-Quick.png",
    name: "Callbreak Quick",
    GAMEID:
      "aa9a9916d6e48ba50afa3c2246b6dacb",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-20-20.png",
    name: "TeenPatti 20-20",
    GAMEID:
      "1afa7db588d05de7b9abca4664542765",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ludo-Quick.png",
    name: "Ludo Quick",
    GAMEID:
      "bb1f14d788d37b06dc8f6701ed57ed0d",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tongits-Go.png",
    name: "Tongits Go",
    GAMEID:
      "26fbfab92a3837b7dbf767e783b173af",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pusoy-Go.png",
    name: "Pusoy Go",
    GAMEID:
      "f2879a3f20f305eadad13448e11c052e",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack.png",
    name: "Blackjack",
    GAMEID:
      "3b502aee6c9e1ef0f698332ee1b76634",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack-Lucky-Ladies.png",
    name: "Blackjack Lucky Ladies",
    GAMEID:
      "d0d1c20062e28493e1750f27a1730c48",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/MINI-FLUSH.png",
    name: "MINI FLUSH",
    GAMEID:
      "07afefc388ab6af8cf26f85286f83fae",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pool-Rummy.png",
    name: "Pool Rummy",
    GAMEID:
      "43e7df819bf57722a8917bb328640b30",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Caribbean-Stud-Poker.png",
    name: "Caribbean Stud Poker",
    GAMEID:
      "04c9784b0b1b162b2c86f9ce353da8b7",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune Gems 3.jpg",
    name: "Fortune Gems 3",
    GAMEID:
      "63927e939636f45e9d6d0b3717b3b1c1",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super Ace Deluxe.jpg",
    name: "Super Ace Deluxe",
    GAMEID:
      "80aad2a10ae6a95068b50160d6c78897",
    provider:
      "jili",
  },
  {
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/3%20Coin%20Treasures.png",
    name: "3 Coin Treasures",
    GAMEID:
      "69c1b4586b5060eefcb45bb479f03437",
    provider:
      "jili",
  },
]

const RummyGames=[
  {
    name: "TeenPatti",
    GAMEID: "f743cb55c2c4b737727ef144413937f4",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti.png",
    provider: "jili"
  },
  {
    name: "AK47",
    GAMEID: "488c377662cad37a551bde18e2fbe785",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/AK47.png",
    provider: "jili"
  },
  {
    name: "Andar Bahar",
    GAMEID: "6f48b3aa0b64c79a2dc320ea021148b5",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Andar-Bahar.png",
    provider: "jili"
  },
  {
    name: "Rummy",
    GAMEID: "ae632f32c3a1e6803f9a6fbec16be28e",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Rummy.png",
    provider: "jili"
  },
  {
    name: "Callbreak",
    GAMEID: "9092b5a56e001c60850c4c1184c53e07",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak.png",
    provider: "jili"
  },
  {
    name: "TeenPatti Joker",
    GAMEID: "1a4eaca67612e65fdcae43f4c8a667a4",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-Joker.png",
    provider: "jili"
  },
  {
    name: "Callbreak Quick",
    GAMEID: "aa9a9916d6e48ba50afa3c2246b6dacb",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Callbreak-Quick.png",
    provider: "jili"
  },
  {
    name: "TeenPatti 20-20",
    GAMEID: "1afa7db588d05de7b9abca4664542765",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TeenPatti-20-20.png",
    provider: "jili"
  },
  {
    name: "Ludo Quick",
    GAMEID: "bb1f14d788d37b06dc8f6701ed57ed0d",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ludo-Quick.png",
    provider: "jili"
  },
  {
    name: "Tongits Go",
    GAMEID: "26fbfab92a3837b7dbf767e783b173af",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Tongits-Go.png",
    provider: "jili"
  },
  {
    name: "Pusoy Go",
    GAMEID: "f2879a3f20f305eadad13448e11c052e",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pusoy-Go.png",
    provider: "jili"
  },
  {
    name: "Blackjack",
    GAMEID: "3b502aee6c9e1ef0f698332ee1b76634",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack.png",
    provider: "jili"
  },
  {
    name: "Blackjack Lucky Ladies",
    GAMEID: "d0d1c20062e28493e1750f27a1730c48",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Blackjack-Lucky-Ladies.png",
    provider: "jili"
  },
  {
    name: "MINI FLUSH",
    GAMEID: "07afefc388ab6af8cf26f85286f83fae",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/MINI-FLUSH.png",
    provider: "jili"
  },
  {
    name: "Pool Rummy",
    GAMEID: "43e7df819bf57722a8917bb328640b30",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pool-Rummy.png",
    provider: "jili"
  },
  {
    name: "Caribbean Stud Poker",
    GAMEID: "04c9784b0b1b162b2c86f9ce353da8b7",
    "game_type": "India Poker Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Caribbean-Stud-Poker.png",
    provider: "jili"
  },
];

const hotGames=[
  {
    name: "Dice",
    GAMEID: "1f3869a4761544f68ce8c9ff04c18adf",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dice.png",
    provider: "jili"
  },
  {
    name: "Lucky Number",
    GAMEID: "f4bfb9bbf261541bc42889fe2da7f281",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Number.png",
    provider: "jili"
  },
  {
    name: "Cricket King 18",
    GAMEID: "dcf220f4e3ecca0278911a55e6f11c77",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-King-18.png",
    provider: "jili"
  },
  {
    name: "Cricket Sah 75",
    GAMEID: "6720a0ce1d06648ff390fbea832798a9",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Cricket-Sah-75.png",
    provider: "jili"
  },
  {
    name: "Fortune Gems 2",
    GAMEID: "664fba4da609ee82b78820b1f570f4ad",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems-2.png",
    provider: "jili"
  },
  {
    name: "Wild Ace",
    GAMEID: "9a3b65e2ae5343df349356d548f3fc4b",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Ace.png",
    provider: "jili"
  },
  {
    name: "Wild Racer",
    GAMEID: "2f0c5f96cda3c6e16b3929dd6103df8e",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Wild-Racer.png",
    provider: "jili"
  },
  {
    name: "World Cup",
    GAMEID: "28374b7ad7c91838a46404f1df046e5a",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/World-Cup.png",
    provider: "jili"
  },
  {
    name: "Happy Taxi",
    GAMEID: "1ed896aae4bdc78c984021307b1dd177",
    "game_type": "Slot Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Happy-Taxi.png",
    provider: "jili"
  }
];

const casinoGames= [
  {
    name: "Dragon & Tiger",
    GAMEID: "dc76761a9dd2b423da6df25a6b65eab1",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-&-Tiger.png",
    provider: "jili"
  },
  {
    name: "7 UP-DOWN",
    GAMEID: "f897d3bfa4061b602cd0ce1d1ea88312",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7-UP-DOWN.png",
    provider: "jili"
  },
  {
    name: "Poker King",
    GAMEID: "a9b13010273fcb0284c9ef436c5fe2ff",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Poker-King.png",
    provider: "jili"
  },
  {
    name: "7up7down",
    GAMEID: "3aca3084a5c1a8c77c52d6147ee3d2ab",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/7up7down.png",
    provider: "jili"
  },
  {
    name: "Baccarat",
    GAMEID: "b9c7c5f589cdaa63c4495e69eaa6dbbf",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Baccarat.png",
    provider: "jili"
  },
  {
    name: "Fortune Bingo",
    GAMEID: "2fd70535a3c838a438b4b8003ecce49d",
    "game_type": "Table Game",
    src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Bingo.png",
    provider: "jili"
  },
];

// const otherGames=[
//   {
//     name: "Royal Fishing",
//     GAMEID: "e794bf5717aca371152df192341fe68b",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Royal-Fishing.png",
//     provider: "jili"
//   },
//   {
//     name: "Bombing Fishing",
//     GAMEID: "e333695bcff28acdbecc641ae6ee2b23",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bombing-Fishing.png",
//     provider: "jili"
//   },
//   {
//     name: "Dinosaur Tycoon",
//     GAMEID: "eef3e28f0e3e7b72cbca61e7924d00f1",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dinosaur-Tycoon.png",
//     provider: "jili"
//   },
//   {
//     name: "Jackpot Fishing",
//     GAMEID: "3cf4a85cb6dcf4d8836c982c359cd72d",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jackpot-Fishing.png",
//     provider: "jili"
//   },
//   {
//     name: "Dragon Fortune",
//     GAMEID: "1200b82493e4788d038849bca884d773",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-Fortune.png",
//     provider: "jili"
//   },
//   {
//     name: "Mega Fishing",
//     GAMEID: "caacafe3f64a6279e10a378ede09ff38",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mega-Fishing.png",
//     provider: "jili"
//   },
//   {
//     name: "Boom Legend",
//     GAMEID: "f02ede19c5953fce22c6098d860dadf4",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boom-Legend.png",
//     provider: "jili"
//   },
//   {
//     name: "Happy Fishing",
//     GAMEID: "71c68a4ddb63bdc8488114a08e603f1c",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Happy-Fishing.png",
//     provider: "jili"
//   },
//   {
//     name: "All-star Fishing",
//     GAMEID: "9ec2a18752f83e45ccedde8dfeb0f6a7",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/All-star-Fishing.png",
//     provider: "jili"
//   },
//   {
//     name: "Dinosaur Tycoon II",
//     GAMEID: "bbae6016f79f3df74e453eda164c08a4",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dinosaur-Tycoon-II.png",
//     provider: "jili"
//   },
//   {
//     name: "Ocean King Jackpot",
//     GAMEID: "564c48d53fcddd2bcf0bf3602d86c958",
//     "game_type": "Fish Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ocean-King-Jackpot.png",
//     provider: "jili"
//   },
//   {
//     name: "Chin Shi Huang",
//     GAMEID: "24da72b49b0dd0e5cbef9579d09d8981",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Chin-Shi-Huang.png",
//     provider: "jili"
//   },
//   {
//     name: "God Of Martial",
//     GAMEID: "21ef8a7ddd39836979170a2e7584e333",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/God-Of-Martial.png",
//     provider: "jili"
//   },
//   {
//     name: "Hot Chilli",
//     GAMEID: "c845960c81d27d7880a636424e53964d",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hot-Chilli.png",
//     provider: "jili"
//   },
//   {
//     name: "Fortune Tree",
//     GAMEID: "6a7e156ceec5c581cd6b9251854fe504",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Tree.png",
//     provider: "jili"
//   },
//   {
//     name: "War Of Dragons",
//     GAMEID: "4b1d7ffaf9f66e6152ea93a6d0e4215b",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/War-Of-Dragons.png",
//     provider: "jili"
//   },
//   {
//     name: "Gem Party",
//     GAMEID: "756cf3c73a323b4bfec8d14864e3fada",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Gem-Party.png",
//     provider: "jili"
//   },
//   {
//     name: "Lucky Ball",
//     GAMEID: "893669898cd25d9da589a384f1d004df",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Ball.png",
//     provider: "jili"
//   },
//   {
//     name: "Hyper Burst",
//     GAMEID: "a47b17970036b37c1347484cf6956920",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hyper-Burst.png",
//     provider: "jili"
//   },
//   {
//     name: "Shanghai Beauty",
//     GAMEID: "795d0cae623cbf34d7f1aa93bbcded28",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Shanghai-Beauty.png",
//     provider: "jili"
//   },
//   {
//     name: "Fa Fa Fa",
//     GAMEID: "54c41adcf43fdb6d385e38bc09cd77ca",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fa-Fa-Fa.png",
//     provider: "jili"
//   },
//   {
//     name: "Candy Baby",
//     GAMEID: "2cc3b68cbcfacac2f7ef2fe19abc3c22",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Candy-Baby.png",
//     provider: "jili"
//   },
//   {
//     name: "Hawaii Beauty",
//     GAMEID: "6409b758471b6df30c6b137b49f4d92e",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Hawaii-Beauty.png",
//     provider: "jili"
//   },
//   {
//     name: "SevenSevenSeven",
//     GAMEID: "61d46add6841aad4758288d68015eca6",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/SevenSevenSeven.png",
//     provider: "jili"
//   },
//   {
//     name: "Bubble Beauty",
//     GAMEID: "a78d2ed972aab8ba06181cc43c54a425",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bubble-Beauty.png",
//     provider: "jili"
//   },
//   {
//     name: "FortunePig",
//     GAMEID: "8488c76ee2afb8077fbd7eec62721215",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/FortunePig.png",
//     provider: "jili"
//   },
//   {
//     name: "Crazy777",
//     GAMEID: "8c62471fd4e28c084a61811a3958f7a1",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy777.png",
//     provider: "jili"
//   },
//   {
//     name: "Bao boon chin",
//     GAMEID: "8c4ebb3dc5dcf7b7fe6a26d5aadd2c3d",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bao-boon-chin.png",
//     provider: "jili"
//   },
//   {
//     name: "Night City",
//     GAMEID: "78e29705f7c6084114f46a0aeeea1372",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Night-City.png",
//     provider: "jili"
//   },
//   {
//     name: "Fengshen",
//     GAMEID: "09699fd0de13edbb6c4a194d7494640b",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fengshen.png",
//     provider: "jili"
//   },
//   {
//     name: "Crazy FaFaFa",
//     GAMEID: "a57a8d5176b54d4c825bd1eee8ab34df",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-FaFaFa.png",
//     provider: "jili"
//   },
//   {
//     name: "XiYangYang",
//     GAMEID: "5a962d0e31e0d4c0798db5f331327e4f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/XiYangYang.png",
//     provider: "jili"
//   },
//   {
//     name: "DiamondParty",
//     GAMEID: "48d598e922e8c60643218ccda302af08",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/DiamondParty.png",
//     provider: "jili"
//   },
//   {
//     name: "Golden Bank",
//     GAMEID: "c3f86b78938eab1b7f34159d98796e88",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Bank.png",
//     provider: "jili"
//   },
//   {
//     name: "Dragon Treasure",
//     GAMEID: "c6955c14f6c28a6c2a0c28274fec7520",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dragon-Treasure.png",
//     provider: "jili"
//   },
//   {
//     name: "Charge Buffalo",
//     GAMEID: "984615c9385c42b3dad0db4a9ef89070",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo.png",
//     provider: "jili"
//   },
//   {
//     name: "Lucky Goldbricks",
//     GAMEID: "d84ef530121953240116e3b2e93f6af4",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Goldbricks.png",
//     provider: "jili"
//   },
//   {
//     name: "Super Ace",
//     GAMEID: "bdfb23c974a2517198c5443adeea77a8",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Ace.png",
//     provider: "jili"
//   },
//   {
//     name: "Money Coming",
//     GAMEID: "db249defce63610fccabfa829a405232",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Money-Coming.png",
//     provider: "jili"
//   },
//   {
//     name: "Golden Queen",
//     GAMEID: "8de99455c2f23f6827666fd798eb80ef",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Queen.png",
//     provider: "jili"
//   },
//   {
//     name: "Jungle King",
//     GAMEID: "4db0ec24ff55a685573c888efed47d7f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jungle-King.png",
//     provider: "jili"
//   },
//   {
//     name: "Monkey Party",
//     GAMEID: "fd369a4a7486ff303beea267ec5c8eff",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Monkey-Party.png",
//     provider: "jili"
//   },
//   {
//     name: "Boxing King",
//     GAMEID: "981f5f9675002fbeaaf24c4128b938d7",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Boxing-King.png",
//     provider: "jili"
//   },
//   {
//     name: "Secret Treasure",
//     GAMEID: "1d1f267e3a078ade8e5ccd56582ac94f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Secret-Treasure.png",
//     provider: "jili"
//   },
//   {
//     name: "Pharaoh Treasure",
//     GAMEID: "c7a69ab382bd1ff0e6eb65b90a793bdd",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pharaoh-Treasure.png",
//     provider: "jili"
//   },
//   {
//     name: "Lucky Coming",
//     GAMEID: "ba858ec8e3b5e2b4da0d16b3a2330ca7",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Coming.png",
//     provider: "jili"
//   },
//   {
//     name: "Super Rich",
//     GAMEID: "b92f491a63ac84b106b056e9d46d35c5",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Rich.png",
//     provider: "jili"
//   },
//   {
//     name: "RomaX",
//     GAMEID: "e5ff8e72418fcc608d72ea21cc65fb70",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/RomaX.png",
//     provider: "jili"
//   },
//   {
//     name: "Golden Empire",
//     GAMEID: "490096198e28f770a3f85adb6ee49e0f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Empire.png",
//     provider: "jili"
//   },
//   {
//     name: "Fortune Gems",
//     GAMEID: "a990de177577a2e6a889aaac5f57b429",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Gems.png",
//     provider: "jili"
//   },
//   {
//     name: "Crazy Hunter",
//     GAMEID: "69082f28fcd46cbfd10ce7a0051f24b6",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Hunter.png",
//     provider: "jili"
//   },
//   {
//     name: "Party Night",
//     GAMEID: "d505541d522aa5ca01fc5e97cfcf2116",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Party-Night.png",
//     provider: "jili"
//   },
//   {
//     name: "Magic Lamp",
//     GAMEID: "582a58791928760c28ec4cef3392a49f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Magic-Lamp.png",
//     provider: "jili"
//   },
//   {
//     name: "Agent Ace",
//     GAMEID: "8a4b4929e796fda657a2d38264346509",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Agent-Ace.png",
//     provider: "jili"
//   },
//   {
//     name: "TWIN WINS",
//     GAMEID: "c74b3cbda5d16f77523e41c25104e602",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/TWIN-WINS.png",
//     provider: "jili"
//   },
//   {
//     name: "Ali Baba",
//     GAMEID: "cc686634b4f953754b306317799f1f39",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Ali-Baba.png",
//     provider: "jili"
//   },
//   {
//     name: "Mega Ace",
//     GAMEID: "eba92b1d3abd5f0d37dfbe112abdf0e2",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mega-Ace.png",
//     provider: "jili"
//   },
//   {
//     name: "Medusa",
//     GAMEID: "2c17b7c4e2ce5b8bebf4bd10e3e958d7",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Medusa.png",
//     provider: "jili"
//   },
//   {
//     name: "Book of Gold",
//     GAMEID: "6b283c434fd44250d83b7c2420f164f9",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Book-of-Gold.png",
//     provider: "jili"
//   },
//   {
//     name: "Thor X",
//     GAMEID: "7e6aa773fa802aaa9cb1f2fac464736e",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Thor-X.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Gold Rush",
//     GAMEID: "2a5d731e0fd60f52873a24ece11f2c0b",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Gold-Rush.png",
//     provider: "jili"
//   },
//   {
//     name: "Mayan Empire",
//     GAMEID: "5c2383ef253f9c36dacec4b463d61622",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Mayan-Empire.png",
//     provider: "jili"
//   },
//   {
//     name: "Crazy Pusher",
//     GAMEID: "00d92d5cec10cf85623938222a6c2bb6",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Crazy-Pusher.png",
//     provider: "jili"
//   },
//   {
//     name: "Bone Fortune",
//     GAMEID: "aab3048abc6a88e0759679fbe26e6a8d",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bone-Fortune.png",
//     provider: "jili"
//   },
//   {
//     name: "JILI CAISHEN",
//     GAMEID: "11e330c2b23f106815f3b726d04e4316",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/JILI-CAISHEN.png",
//     provider: "jili"
//   },
//   {
//     name: "Bonus Hunter",
//     GAMEID: "39775cdc4170e56c5f768bdee8b4fa00",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bonus-Hunter.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Samba",
//     GAMEID: "6d35789b2f419c1db3926350d57c58d8",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Samba.png",
//     provider: "jili"
//   },
//   {
//     name: "Neko Fortune",
//     GAMEID: "9a391758f755cb30ff973e08b2df6089",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Neko-Fortune.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Pirate Queen",
//     GAMEID: "70999d5bcf2a1d1f1fb8c82e357317f4",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pirate-Queen.png",
//     provider: "jili"
//   },
//   {
//     name: "Golden Joker",
//     GAMEID: "f301fe0b22d1540b1f215d282b20c642",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Joker.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Master Tiger",
//     GAMEID: "d2b48fe98ac2956eeefd2bc4f7e0335a",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Master-Tiger.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Sweet Land",
//     GAMEID: "91250a55f75a3c67ed134b99bf587225",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sweet-Land.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Elf Bingo",
//     GAMEID: "5cec2b309a8845b38f8e9b4e6d649ea2",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Elf-Bingo.png",
//     provider: "jili"
//   },
 
//   {
//     name: "Golden Temple",
//     GAMEID: "976c5497256c020ac012005f6bb166ad",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Temple.png",
//     provider: "jili"
//   },
//   {
//     name: "Devil Fire",
//     GAMEID: "1b4c5865131b4967513c1ee90cba4472",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Devil-Fire.png",
//     provider: "jili"
//   },
//   {
//     name: "Bangla Beauty",
//     GAMEID: "6b60d159f0939a45f7b4c88a9b57499a",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bangla-Beauty.png",
//     provider: "jili"
//   },
//   {
//     name: "Aztec Priestess",
//     GAMEID: "6acff19b2d911a8c695ba24371964807",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Aztec-Priestess.png",
//     provider: "jili"
//   },
//   {
//     name: "Fortune Monkey",
//     GAMEID: "add95fc40f1ef0d56f5716ce45a56946",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune-Monkey.png",
//     provider: "jili"
//   },
//   {
//     name: "Dabanggg",
//     GAMEID: "5404a45b06826911c3537fdf935c281f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Dabanggg.png",
//     provider: "jili"
//   },
//   {
//     name: "Sin City",
//     GAMEID: "830cac2f5da6cc1fb91cfae04b85b1e2",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sin-City.png",
//     provider: "jili"
//   },
//   {
//     name: "King Arthur",
//     GAMEID: "fafab1a17a237d0fc0e50c20d2c2bf4c",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/King-Arthur.png",
//     provider: "jili"
//   },
//   {
//     name: "Charge Buffalo Ascent",
//     GAMEID: "28bc4a33c985ddce6acd92422626b76f",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Charge-Buffalo-Ascent.png",
//     provider: "jili"
//   },
//   {
//     name: "Witches Night",
//     GAMEID: "82c5c404cf4c0790deb42a2b5653533c",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Witches-Night.png",
//     provider: "jili"
//   },
//   {
//     name: "Fairness Games(BlockLobby)",
//     GAMEID: "1ab8d0997624c05e4aee901af1bf84dc",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fairness-Games(BlockLobby).png",
//     provider: "jili"
//   },
  
  
 
  
//   {
//     name: "Big Small",
//     GAMEID: "25822eb4d6459cc8b39c4f7b69b1bf2c",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Big-Small.png",
//     provider: "jili"
//   },
//   {
//     name: "Number King",
//     GAMEID: "36d20c24669dca7630715f2e0a7c18be",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Number-King.png",
//     provider: "jili"
//   },
//   {
//     name: "Journey West M",
//     GAMEID: "0d0a5a1731a6a05ffeb0e0f9d1948f80",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Journey-West-M.png",
//     provider: "jili"
//   },
  
//   {
//     name: "iRich Bingo",
//     GAMEID: "a53e46bf1e31f7a960ae314dc188e8b3",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/iRich-Bingo.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Sic Bo",
//     GAMEID: "de0dc8a7fd369bd39a2d5747be87825c",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Sic-Bo.png",
//     provider: "jili"
//   },
//   {
//     name: "Super Bingo",
//     GAMEID: "c934e67c2a84f52ef4fb598b56f3e7ba",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "Bingo Carnaval",
//     GAMEID: "d419ec9ab6a23590770fd77b036aed16",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bingo-Carnaval.png",
//     provider: "jili"
//   },
//   {
//     name: "Win Drop",
//     GAMEID: "8211bc6e55e84d266bef9a6960940183",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Win-Drop.png",
//     provider: "jili"
//   },
//   {
//     name: "Lucky Bingo",
//     GAMEID: "c9f2470e285f3580cd761ba2e1f067e1",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Lucky-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "Jackpot Bingo",
//     GAMEID: "780d43c0a98bc8f6a0705976605608c3",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Jackpot-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "Color Game",
//     GAMEID: "2ac4917fbc8b2034307b0c3cdd90d416",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Game.png",
//     provider: "jili"
//   },
//   {
//     name: "Go Goal BIngo",
//     GAMEID: "4e5ddaa644badc5f68974a65bf7af02a",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Go-Goal-BIngo.png",
//     provider: "jili"
//   },
//   {
//     name: "Calaca Bingo",
//     GAMEID: "b2f05dae5370035a2675025953d1d115",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Calaca-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "PAPPU",
//     GAMEID: "e5091890bbb65a5f9ceb657351fa73c1",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/PAPPU.png",
//     provider: "jili"
//   },
//   {
//     name: "West Hunter Bingo",
//     GAMEID: "8d2c1506dc4ae4c47d23f9359d71c360",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/West-Hunter-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "Bingo Adventure",
//     GAMEID: "2303867628a9a62272da7576665bbc65",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Bingo-Adventure.png",
//     provider: "jili"
//   },
//   {
//     name: "Golden Land",
//     GAMEID: "05fc951a633d4c6b4bbe8c429cd63658",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Golden-Land.png",
//     provider: "jili"
//   },
//   {
//     name: "Candyland Bingo",
//     GAMEID: "711acbdf297ce40a09dd0e9023b63f50",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Candyland-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "Color Prediction",
//     GAMEID: "4a64504353c2304a3061bfd31cd9a62e",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Color-Prediction.png",
//     provider: "jili"
//   },
//   {
//     name: "Magic Lamp Bingo",
//     GAMEID: "848ac1703885d5a86b54fbbf094b3b63",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Magic-Lamp-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "Pearls of Bingo",
//     GAMEID: "0995142f4685f66dfdd1a54fffa66ffa",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Pearls-of-Bingo.png",
//     provider: "jili"
//   },
//   {
//     name: "European Roulette",
//     GAMEID: "d4fc911a31b3a61edd83bdd95e36f3bf",
//     "game_type": "Table Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/European-Roulette.png",
//     provider: "jili"
//   },
  
//   {
//     name: "Fortune Gems 3",
//     GAMEID: "63927e939636f45e9d6d0b3717b3b1c1",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Fortune Gems 3.jpg",
//     provider: "jili"
//   },
//   {
//     name: "Super Ace Deluxe",
//     GAMEID: "80aad2a10ae6a95068b50160d6c78897",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/Super Ace Deluxe.jpg",
//     provider: "jili"
//   },
//   {
//     name: "3 Coin Treasures",
//     GAMEID: "69c1b4586b5060eefcb45bb479f03437",
//     "game_type": "Slot Game",
//     src: "https://huidu-bucket.s3.ap-southeast-1.amazonaws.com/api/jili/3 Coin Treasures.png",
//     provider: "jili"
//   }
// ];


  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Latest Games</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/jiliAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={AllGames} />
                  </div>
                </div>

                <div className="newMain mt-5 mb-5 brdr">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Hot Games</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/jiliAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={hotGames} />
                  </div>
                </div>

                <div className="newMain mt-5 mb-5 brdr">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Casino</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/jiliAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={casinoGames} />
                  </div>
                </div>

                <div className="newMain mt-5 mb-5 brdr">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Rummy</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/jiliAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={RummyGames} />
                  </div>
                </div>

                <div className="newMain mt-5 mb-5 brdr">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Slots</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/jiliAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={SlotsGames} />
                  </div>
                </div>

                {/* <div className="newMain mt-5 mb-5 brdr">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">Others</span>{" "}
                    <span className="all cursor-pointer" onClick={()=> navigate('/jiliAll')}>See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={otherGames} />
                  </div>
                </div> */}


                

                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default Jili;
